import * as React from "react";
import { Icon } from "../Icon";
export class SideArrow extends React.PureComponent {
    render() {
        return (React.createElement("div", { className: `rj-side-arrow rj-side-arrow--${this.props.type}`, "data-uat": this.props.dataUat || `side-arrow-${this.props.type}`, onClick: this.props.onClick },
            React.createElement(Icon, { i: `i-12 arrow-${this.props.type}` })));
    }
}
//# sourceMappingURL=SideArrow.js.map